import FilterShort from '@/icons/filter-short';
import { Button } from '@/shadcn-ui/button';
import QuickFilterPills from './quick-filter-pills/quick-filter-pills';
import { InventoryFiltersResponse } from '@/catalog/hooks/use-inventory-filters';
import { cn } from '@/shadcn-ui/utils';

interface MobileFilterHeaderProps
  extends Pick<InventoryFiltersResponse, 'selectedFilters' | 'setSelectedFilters'> {
  onClickDelegate: () => void;
  filterCount?: number;
  className?: string;
  hideQuickFilterPills?: boolean;
}

export default function MobileFilterHeader({
  onClickDelegate,
  selectedFilters,
  setSelectedFilters,
  filterCount,
  className,
  hideQuickFilterPills = false,
}: MobileFilterHeaderProps) {
  return (
    // Need z-10 to bring this block above the vehicle tiles on mobile view
    <div
      className={cn(
        'sticky top-0 z-10 flex w-full items-center bg-flexcar-neutral100 px-[24px] py-[8px] lg:hidden',
        className
      )}
    >
      <Button
        variant="clear"
        className="flex h-auto items-center gap-[6px]"
        onClick={onClickDelegate}
      >
        <FilterShort className="flex-shrink-0" />
        <p className="body2-strong whitespace-nowrap text-flexcar-blue40">
          Filter{filterCount && filterCount > 0 ? ` (${filterCount})` : ''}
        </p>
      </Button>
      {!hideQuickFilterPills ? (
        <QuickFilterPills
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      ) : null}
    </div>
  );
}
